import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";
import { useMemo } from "react";

export const useGetTableHistory = () => {
  const axios = useMemo(() => createAxiosWithAuth(), []);
  
  return useMutation({
    mutationKey: ["fuel-requests-all-history"],
    mutationFn: async (query) => {
      return await axios.post("/fuelrequest/list", query);
    },
  });
};
